import React from 'react';
import spinner from './spinner.gif';

function Spinner() {
    return <img src={spinner} alt="spinner..." style={spinnerStyle} />;
}

const spinnerStyle = {
    paddingTop: '100px',
    paddingBottom: '500px',
    width: '100px',
    margin: 'auto',
    display: 'block',
};

export const MiniSpinner = () => {
    return (
        <div className="text-center my-3">
            <div
                className="spinner-border text-primary"
                style={miniSpinnerStyle}
            ></div>
        </div>
    );
};

const miniSpinnerStyle = {
    width: '5rem',
    height: '5rem',
    margin: 'auto',
    display: 'block',
};

// export const LoadingSpinner = () => {
//     return (
//         <div className="text-center my-3">
//             <button
//                 class="btn btn-primary"
//                 type="button"
//                 disabled
//                 style={loadingSpinnerStyle}
//             >
//                 <span
//                     class="spinner-border spinner-border-sm"
//                     role="status"
//                     aria-hidden="true"
//                 ></span>
//                 &nbsp; Loading Sales...
//             </button>{' '}
//         </div>
//     );
// };

// const loadingSpinnerStyle = {
//     margin: 'auto',
//     display: 'block',
// };

export default Spinner;
